(function ($) {
  'use strict';

  /**
   * Culture - Countdown/Article - v1
   */

  Drupal.behaviors.cultureLiveEventV1 = {
    get: function (key) {
      return cultureLiveEventV1[key];
    },

    set: function (key, val) {
      cultureLiveEventV1[key] = val;
    },

    attach: function (context, settings) {
      if (window.location.protocol == 'https:') {
        window.location = 'http:' + window.location.hostname + window.location.pathname;
      }
      sessionStorage.setItem('IGNORE_GEO', '1');
    }
  };
})(jQuery);
